import { Customer, GetAllCustomers, SimplifiedCustomer } from "../../Models/Customer";
import { PagedResult } from "../../Models/PagedResult";
import api from "../axios";

export const customerService = {
  get: async (id: string): Promise<Customer> => {
    const response = await api.get(`/customer/${id}`);
    return response.data;
  },

  getCount: async (): Promise<number> => {
    const response = await api.get('/customer/count');
    return response.data;
  },

  getAll: async (data: GetAllCustomers): Promise<PagedResult<SimplifiedCustomer>> => {
    const queryParams = new URLSearchParams();

    queryParams.append("page", data.page.toString());
    queryParams.append("pageSize", data.pageSize.toString());

    if (data.search) {
      queryParams.append("search", data.search);
    }

    const response = await api.get(`/customer?${queryParams.toString()}`);
    return response.data;
  },

  create: async (customer: Customer) => {
    const response = await api.post('/customer', customer);
    return response.data;
  },

  update: async (customer: Customer) => {
    const response = await api.put('/customer', customer);
    return response.data;
  }
};
